<template>
  <div>
    <h1>One Moment</h1>
    <p>Loading OpenFreight now...</p>
  </div>
</template>

<script>
/**
 * The v2 [shipper] application handover view.
 */
export default {
  async mounted () {
    const response = await fetch(this.getRequest())

    if (response.ok) {
      window
        .location
        .replace(new URL('home', process.env.VUE_APP_LEGACY_SHIPPER_URI))
    } else {
      throw new Error('Failed to establish legacy session')
    }
  },
  methods: {
    getRequest () {
      return new Request(this.getRequestUrl(), {
        method: 'GET',
        cache: 'no-cache',
        redirect: 'error'
      })
    },
    getRequestUrl () {
      return new URL(this.getSearchParameters(), process.env.VUE_APP_LEGACY_MANAGER_URI)
    },
    getSearchParameters () {
      const parameters = new URLSearchParams()

      if (this.$route.query.tenancy) {
        parameters.set('tenancy', this.$route.query.tenancy)
      }

      if (this.$route.query.token) {
        parameters.set('token', this.$route.query.token)
      }

      if (this.$route.query['impersonation-token']) {
        parameters.set('impersonation-token', this.$route.query['impersonation-token'])
      }

      return `?${parameters.toString()}`
    }
  }
}
</script>

<style lang="scss" scoped>
  div:first-of-type {
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 10vw;
  }
</style>
